import type { IPlatformAdapter } from './interfaces/IPlatformAdapter';

/**
 * Node.js implementation of the platform adapter.
 * No-op implementation that doesn't crash but does nothing.
 *
 * @public
 */
export class NodePlatformAdapter implements IPlatformAdapter {

    // #region Methods

    public matchMedia(_query: string): boolean {
        // Default to light mode in Node.js
        return false;
    }

    public setDocumentAttribute(_name: string, _value: string): void {
        // No-op in Node.js
    }

    public getDocumentAttribute(_name: string): string | null {
        // No attributes available in Node.js
        return null;
    }

    public observeDocumentAttributes(
        _attributes: Array<string>,
        _callback: (attributeName: string, newValue: string | null) => void
    ): () => void {
        // No observation possible in Node.js, return no-op unsubscribe
        return () => { };
    }

    // #endregion

}
